/**
 * TimezoneSelect — a consistent IANA timezone dropdown. Used on the
 * Client Overview edit form, the Sales Lead edit form, and anywhere
 * else the app wants an optional per-entity timezone override.
 *
 * Value is the IANA name (e.g. "America/Los_Angeles") or "" for "not
 * set — fall back to inferred timezone".
 */
import { TIMEZONE_OPTIONS } from "@/lib/timezone";

export default function TimezoneSelect({ value, onChange, disabled, placeholder = "— infer from address —", testId }) {
  return (
    <select
      value={value || ""}
      onChange={e => onChange(e.target.value || null)}
      disabled={disabled}
      className="w-full border border-[#E5E5E5] px-3 py-1.5 text-sm focus:outline-none focus:border-[#0055FF] disabled:bg-[#FAFAFA]"
      data-testid={testId || "timezone-select"}
    >
      <option value="">{placeholder}</option>
      {TIMEZONE_OPTIONS.map(o => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
      {value && !TIMEZONE_OPTIONS.some(o => o.value === value) && (
        <option value={value}>{value} (custom)</option>
      )}
    </select>
  );
}
